import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import portrait1 from "./../assets/joanie.jpg";
import portrait2 from "./../assets/gregory.jpg";
import quote from "./../assets/quote.svg";
import { useTranslation, Trans } from "react-i18next";

const Testimonials = () => {
  const { t } = useTranslation();

  const testimonialsText = t("testimonials", { returnObjects: true });

  const testimonials = [
    { ...testimonialsText[0], image: portrait1 },
    { ...testimonialsText[1], image: portrait2 }
  ];

  const [current, setCurrent] = useState(0);

  const prevSlide = () => setCurrent(prev => (prev === 0 ? testimonials.length - 1 : prev - 1));
  const nextSlide = () => setCurrent(prev => (prev === testimonials.length - 1 ? 0 : prev + 1));
  const goToSlide = index => setCurrent(index);

  return (
    <section id="testim" className="testim mt-5">
      <div className="wrap">
        <button className="arrow left" onClick={prevSlide} aria-label="Previous slide">
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
        <button className="arrow right" onClick={nextSlide} aria-label="Next slide">
          <FontAwesomeIcon icon={faChevronRight} />
        </button>

        <ul className="dots">
          {testimonials.map((_, index) => (
            <li
              key={index}
              className={`dot ${index === current ? "active" : ""}`}
              onClick={() => goToSlide(index)}
            ></li>
          ))}
        </ul>

        <div className="cont">
          {testimonials.map((t, index) => (
            <div key={index} className={`slide ${index === current ? "active" : ""}`}>
              <div className="img">
                <img src={t.image} alt={t.name} />
              </div>
              <h2>{t.name}</h2>
              <h3>{t.function}</h3>
              <p>
                <Trans i18nKey={`testimonials.${index}.text`} components={{ bold: <b /> }} />
                <img src={quote} alt="quote" className="quote quote-top-left" />
                <img src={quote} alt="quote" className="quote quote-bottom-right" />
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
